export enum Routes {
  Home = '/',
  Profile = '/profile',
  Unauthorized = '/unauthorized',
}

export * from './ProtectedRoute';
